let OnlineUsers = {
    url: `https://api.habbotools.com/v1/origins/statistics`,
    getData: async function () {
        const response = await fetch(OnlineUsers.url, {
            method: "GET",
        });
        const data = await response.json();
        const htmlContainerES = document.getElementById(
            `hotel_es_online-users`
        );
        const htmlContainerCOM = document.getElementById(
            `hotel_com_online-users`
        );
        const htmlContainerBR = document.getElementById(
            `hotel_br_online-users`
        );
        htmlContainerES.innerHTML = parseInt(data.data.es) || 0;
        htmlContainerCOM.innerHTML = parseInt(data.data.com) || 0;
        htmlContainerBR.innerHTML = parseInt(data.data.br) || 0;
    },

    init: async function () {
        await OnlineUsers.getData();
    },
};
